<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'UserMenu',
})
</script>
<template>
  <div class="user-wrapper">
    <div class="content-box">
      <!-- <a href="https://github.com/bailihuiyue/ant-design-pro-vue3/blob/main/README.md" target="_blank">
        <span class="action">
          <QuestionCircleOutlined />
        </span>
      </a> -->
      <!-- <notice-icon class="action" /> -->
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <!-- <a-avatar class="avatar" size="small" :src="UserInfo.avatar" /> -->
          <span class="nickname">
            <img :src="avatarSrc" width="44px" height="44px" style="border-radius: 50%;" />
            {{ userInfos.roleType == 'admin' ? 'admin' : userInfos?.tel }}
            <DownOutlined class="pl-[10px]" />
          </span>
        </span>
        <template #overlay>
          <a-menu class="user-dropdown-menu-wrapper">
            <!-- <a-menu-item key="0">
            <router-link :to="{ name: 'center' }">
              <a-icon type="user" />
              <span>个人中心</span>
            </router-link>
            </a-menu-item>-->
            <!-- <a-menu-item key="1">
            <router-link :to="{ name: 'settings' }">
              <a-icon type="setting" />
              <span>账户设置</span>
            </router-link>
            </a-menu-item>-->
            <!-- <a-menu-item key="4" @click="showSystemSetting">
              <a>
                <SettingOutlined />
                <span>{{ $t('tools.userMenu.systemConfig') }}</span>
              </a>
            </a-menu-item> -->
            <a-menu-item key="5" @click="changePwd">
              <a>
                <LockOutlined />
                <span>修改密码</span>
              </a>
            </a-menu-item>
            <!-- <a-menu-item key="2" disabled>
              <SettingOutlined />
              <span>{{ $t('tools.userMenu.test') }}</span>
            </a-menu-item>-->
            <a-menu-divider />
            <a-menu-item key="3">
              <a href="javascript:;" @click="handleLogout">
                <LogoutOutlined />
                <span>退出登录</span>
              </a>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
      <!-- <span style="overflow: hidden;display: inline-block;">
        <SelectLang :class="theme" class="action" />
      </span> -->
    </div>
    <changePwdDialog ref="dialogRef" />
  </div>
</template>

<script lang="ts" setup name="UserMenu">
import { Modal } from 'ant-design-vue'
import { DownOutlined, LogoutOutlined, LockOutlined } from '@ant-design/icons-vue'
import { systemConfig } from '@/store/reactiveState'
import { useRouter } from 'vue-router'
import { clearUserInfo } from '@/utils/util'
import logo from '@/assets/picLogo.png'
import { storeToRefs } from 'pinia'
import { useLogin } from '@/store/login'
import { onMounted, ref, computed } from 'vue'
import changePwdDialog from '@/components/tools/changePwd.vue'
import { resetBusinessRoutes } from '@/router/businessRoutes'

const props = defineProps(['theme'])
const router = useRouter()

const loginApi = useLogin()
const { userInfos } = storeToRefs(loginApi)
const dialogRef = ref()

const avatarSrc = computed(() => {
  const pic = userInfos.value?.pic
  if (pic && /^https?:\/\//i.test(pic)) {
    return pic
  }
  return logo
})

onMounted(async () => {
  ; (await loginApi.getUserInfo()) as any
  const { pwdSign } = userInfos.value as any
  if (pwdSign === '1') {
    dialogRef.value.openDialog(0)
  }
})

const changePwd = () => {
  dialogRef.value.openDialog(1)
}

const handleLogout = () => {
  Modal.confirm({
    title: '提示',
    content: '真的要退出登录吗？',
    onOk: () => {
      loginApi.logout().then((res) => {
        clearUserInfo()
        resetBusinessRoutes(router)
        loginApi.$reset()
        router.replace({ name: 'login' })
      })
    },
    onCancel() { }
  })
}
const showSystemSetting = () => {
  systemConfig.commit('SET_SETTING_DRAWER', true)
}
</script>
<style lang="less">
.user-dropdown-menu-wrapper {
  .ant-dropdown-menu-item {
    width: 100% !important;
  }
}
</style>
